'use strict';

import { environment } from '@quartz-iam-legacy/environments/environment';

angular.module('systemOwnerUserRequestControllers')

.factory('systemOwnerUserRequestService', ['$http', '$q', function ($http, $q) {

    var service = {};

    var baseUrl = environment.apiUrl + '/ID/SystemOwner/UserRequest/API';

    // **** HttpGet

    service.getCardsToProcess = function (authLogin) {
        return $http.get(baseUrl + '/Card/ToProcess', {})
                    .then(function (response) {
                        return response.data;
                    });
    }

    // **** HttpPost

    service.authorizeUserRequestSystem = function (userAccessRequestId, systemId) {
        return $http.post(baseUrl + '/Authorize' +
                          '/UserRequest/' + userAccessRequestId +
                          '/System/' + systemId, {})
                    .then(function (response) {
                        return response.data;
                    });
    }

    service.authorizeUserRequestSystems = function (userAccessRequestId, systemIds) {
        return $http.post(baseUrl + '/Authorize' +
                          '/UserRequest/' + userAccessRequestId +
                          '/System',
                          { SystemIDs: systemIds })
                    .then(function (response) {
                        return response.data;
                    });
    }

    service.rejectUserRequestSystem = function (userAccessRequestId, systemId) {
        return $http.post(baseUrl + '/Reject' +
                          '/UserRequest/' + userAccessRequestId +
                          '/System/' + systemId, {})
                    .then(function (response) {
                        return response.data;
                    });
    }

    return service;
}]);
